const getColorVariants = (sticks) => sticks.reduce((colorVariants, { swatch_data, flavour_label }) => {
    if (!swatch_data || !flavour_label) {
        return colorVariants;
    }
    colorVariants.push({ value: swatch_data, label: flavour_label });
    return colorVariants;
}, []);
export const getSticksMatrixColorVariants = (sticksData, productSku) => Object.values(sticksData).reduce((colorVariants, { onetime, subscription }) => {
    if (onetime.find(({ sku }) => sku === productSku)) {
        return getColorVariants(onetime);
    }
    if (subscription.find(({ sku }) => sku === productSku)) {
        return getColorVariants(subscription);
    }
    return colorVariants;
}, []);
//# sourceMappingURL=getSticksMatrixColorVariants.js.map